import {React,useState,useRef} from "react";
import ContactPopup from "../ContactPopup";
// import "../ImportExport/ServicePages.css";
import "../ImportExport/ServicePages.css";

const PrivateLimitedClosure = () => {
const [openPopup, setOpenPopup] = useState(false);
  
    const contactRef = useRef(null);
  
    const scrollToContact = () => {
      contactRef.current?.scrollIntoView({ behavior: "smooth" });
    };


  return (
    <div className="service-page">

      <section className="service-hero">
        <h1>Private Limited Company Closure Service</h1>
        <p className="subtitle">Strike Off & Winding Up Assistance</p>
         <button className="hero-btn" onClick={scrollToContact} >
            Get Started Today
          </button>

      </section>

      {/* <h1>Private Limited Company Closure Service</h1>
      <p className="subtitle">
        Strike Off & Winding Up Assistance
      </p> */}

      {/* OVERVIEW */}
      <section className="service-section">
        <h2>Overview</h2>
        <p>
          Closing a Private Limited Company is a legal process under the Companies Act, 2013.
          It involves shutting down operations and removing the company name from ROC records.
        </p>
        <p>
          We provide complete assistance for smooth, hassle-free, and legally compliant closure.
        </p>
      </section>

      {/* METHODS */}
      <section className="service-section">
        <h2>Methods of Closure</h2>

        <div className="card">
          <h3>1. Strike Off (Fast Track)</h3>
          <ul>
            <li>No business activity</li>
            <li>No liabilities</li>
            <li>Bank account closed</li>
            <li>Directors agree to close</li>
          </ul>
        </div>

        <div className="card">
          <h3>2. Voluntary Winding Up</h3>
          <ul>
            <li>Company has assets/liabilities</li>
            <li>Formal liquidation required</li>
            <li>Settlement with creditors</li>
          </ul>
        </div>
      </section>

      {/* SERVICES */}
      <div className="service-section">
        <h2>Our Services Include</h2>
        <ul className="list-grid">  
          <li>✔ Eligibility check</li>
          <li>✔ STK-2 Filing</li>
          <li>✔ Board & Special Resolution</li>
          <li>✔ ROC Compliance clearance</li>
          <li>✔ GST & PAN deregistration</li>
          <li>✔ Bank closure guidance</li>
        </ul>
      </div>

      {/* WHEN TO CLOSE */}
            <div className="service-section">
        <h2>When Should You Close?</h2>
        <ul className="list-grid">
          <li>No business activity</li>
          <li>Startup discontinued</li>
          <li>No transactions</li>
          <li>Reduce compliance cost</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
            <div className="service-section">
        <h2>Documents Required</h2>
        <ul className="list-grid">
          <li>Certificate of Incorporation</li>
          <li>PAN Card</li>
          <li>MOA & AOA</li>
          <li>Financial Statements</li>
          <li>Bank Closure Proof</li>
          <li>Director ID Proof</li>
        </ul>
      </div>

      {/* BENEFITS */}
            <div className="service-section">
        <h2>Benefits</h2>
        <ul className="list-grid">
          <li>✔ Avoid penalties</li>
          <li>✔ No future filings</li>
          <li>✔ Clean legal closure</li>
          <li>✔ Prevent legal notices</li>
        </ul>
      </div>

      {/* CTA */}
      {/* <section className="service-cta">
        <h2>Close Your Company Stress-Free</h2>
        <p>Let our experts handle the entire process.</p>
        <button>Contact Us</button>
      </section> */}
      <div className="cta" ref={contactRef}>
        <h2>Close Your Company Stress-Free</h2>
        <p>Let our experts handle the entire process.</p>

        <div className="cta-buttons">
          <button onClick={() => setOpenPopup(true)}>Contact Us Now</button>
          <ContactPopup
            isOpen={openPopup}
            onClose={() => setOpenPopup(false)}
          />

          <button className="outline" onClick={() => window.location.href = "tel:9218103915"} >Free Consultation</button>
        </div>
      </div>

    </div>
  );
};

export default PrivateLimitedClosure;